/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">

    <ion-header>
      <ion-toolbar color="primary" class="home-statusbar" style="height: 0px;"></ion-toolbar>
    </ion-header>
 	<ion-content color="primary">

    <div class="sticky">
    <div class="d-flex ion-justify-content-center" style="height: 70px">
      <img class="ion-margin-bottom ion-margin-top" src="/assets/home.png" alt="" />
    </div>

    <div v-if="showModuleSelector && numberOfModule > 1" class="ion-padding-bottom d-flex justify-center">
      <ion-segment v-if="this.appModule.CARPOOL" class="module-segment" value="hitchHiking" mode="ios" @ionChange="moduleChanged($event)">
        <ion-segment-button value="carpool" mode="ios">
          <ion-label>{{ $t('Modules.carpool') }}</ion-label>
        </ion-segment-button>
        <ion-segment-button v-if="this.appModule.HITCHHIKING" value="hitchHiking" mode="ios">
          <ion-label>{{ $t('Modules.hitchHiking') }}</ion-label>
        </ion-segment-button>
        <ion-segment-button v-if="this.appModule.SOLIDARYTRANSPORT" value="solidary" mode="ios">
          <ion-label>{{ $t('Modules.solidary') }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
    </div>


      <UserHomeHitchHiking />

      <div class="mc-white-container" style="min-height: 100%;">

        <div v-if="showRelaypoints && !!this.$store.state.userStore.user">
          <RelaypointsMap :filter="'pouce'" />
          <br><br>
        </div>

        <div class="relative">
          <img class="personnage" src="../assets/images/Personnage.png"/>
        <div style="margin-left: 40%;">
        <div class="t1">
          DES TRAJETS DU QUOTIDIEN<br>
          ENTRE VOISIN.E.S
        </div>
        <div class="mb-15 d-flex">
          <img class="block-img" src="../assets/images/Sympa.png">
          <div class="block">
            <div class="t2">C'est <b>SYMPA</b></div>
            Partager ses trajets, c'est rencontrer ses voisin.e.s, échanger avec ses collègues et créer du lien social !
          </div>
        </div>
        <div class="mb-15 d-flex">
          <img class="block-img" src="../assets/images/Ecoresponsable.png">
          <div class="block">
            <div class="t2">C'est <b>ÉCORESPONSABLE</b></div>
            Partager ses trajets, c'est moins de voitures sur les routes et donc moins de CO<sub>2</sub>.
          </div>
        </div>
        <div class="mb-15 d-flex">
          <img class="block-img" src="../assets/images/BonSens.png">
          <div class="block">
            <div class="t2">C'est <b>DU BON SENS</b></div>
            Une voiture peut transporter jusqu'à 5 personnes et même parfois plus. Alors, transformons la voiture en nouveau mode de transport en commun !
          </div>
        </div>
        </div>
        </div>

        <ion-button
          class="mc-big-button"
          color="primary"
          expand="block"
          fill="outline"
          v-if="!!this.$store.state.userStore.user && this.$store.state.userStore.user.verifiedIdentity"
          href="https://rezopouce.fr/destination/create"
          target="_blank"
        >
          <ion-icon name="images" class="ion-padding-end"></ion-icon>
          {{ $t('HitchHiking.home.destination') }}
        </ion-button>

        <BlockAction
                     :action="'hitchHiking'"
                     :color="'rgba('+  secondary + ', 1)'"
                     :colorBg="'rgba('+ secondary  + ', 0.4)'"
                     :icon="''"
                     @clickButton="redirectToPratique()"
        />

        <ion-button
          v-if="!isNotCapacitor && canSeeDynamics"
          class="mc-big-button"
          color="secondary"
          expand="block"
          fill="outline"
          @click="goToDynamic()"
        >{{ $t('HOME.dynamic') }}</ion-button>

        <ion-button
          class="mc-text-button"
          color="medium"
          expand="block"
          fill="outline"
          v-on:click="redirectToFAQ()"
        >
          {{ $t('HOME.FAQ') }}
        </ion-button>

        <ion-button
          class="mc-text-button"
          color="medium"
          expand="block"
          fill="outline"
          v-on:click="redirectToContact()"
        >
          {{ $t('HOME.contact') }}
        </ion-button>

      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
.mc-container {
  padding: 30px;
  background-image: url('../../assets/icons/banner.png');
  background-repeat: no-repeat;
  // background-size: 100%;
  background-size: cover;
  background-position: center;
  margin-bottom: -10px;
}

.module-segment {

  ion-segment-button {
    --padding-bottom: 5px;
    --padding-top: 5px;
    --border-radius: 10px;
  }
}

.mc-download-app {
  border-radius: 10px;
  margin-bottom: 20px;
  color: white;
  padding: 20px;
  background: rgba(var(--ion-color-primary-rgb), 0.4);

  p {
    margin: 0px;
    margin-bottom: 20px;
  }
}

.partner-img {
  width: 75%;
  object-fit: contain;
  // max-height: 100px;
}

.mc-home-header {
  .mc-home-log {
    display: flex;
    align-items: center;

    img {
      // width: 26px;
      height: 48px;
      // margin-top: 6px;
      // margin-bottom: 6px;
    }

    h1 {
      margin: 0;
      padding: 0;
      font-weight: bold;
    }

    p {
      margin: 0;
      padding: 0;
      font-weight: bold;
    }


  }


}

.header-img {
  width: 130px;
  right: calc(50% - 65px);
  margin-right: 0px !important;
  position: fixed;
  top: 8px;
  z-index: 999999;
}

.plt-capacitor.plt-ios .header-img {
  top: 25px !important;
}

.mc-home-switch {
  position: absolute;
  top: 10px;
  right: 10px;
}

.t1 {
  color: var(--ion-color-primary);
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 20px;
}

.t2 {
  font-size: 13px;
  color: var(--ion-color-secondary);
  margin-bottom: 5px;
}

.mb-15 {
  margin-bottom: 15px;
}

.block {
  font-size: 11px;
  line-height: 15px;
}

.block-img {
  width: 40px;
  height: 40px;
  margin-right: 10px;
}

.relative {
  position: relative;
  margin-left: -20px;
}

.personnage {
  position: absolute;
  top: 0px;
  left: -0px;
  height: 100%;
  max-width: 45%;
  object-fit: cover;
  object-position: right top;
}
</style>

<script>
import ModuleModal from "../../Shared/Component/ModuleModal.component";

import {isPlatform} from "@ionic/core";
import UserHomeHitchHiking from "./UserHomeHitchHiking.component";
import MiniMap from "../../Carpools/Shared/Components/MiniMap.component";
import RelaypointsMap from "../../Carpools/Shared/Components/RelaypointsMap.component";
import {toast} from "../../Shared/Mixin/toast.mixin";
import BlockAction from "../../Carpools/Home/Components/BlockAction.component.vue";
import {popoverController} from "@ionic/vue";


export default {
  name: "hitchHiking.home",
  components: {
    RelaypointsMap,
    UserHomeHitchHiking,
    BlockAction
  },
  mixins: [toast],
  data() {
    return {
      title: process.env.VUE_APP_TITLE,
      subtitle: process.env.VUE_APP_SUBTITLE,
      primary: "",
      secondary: "",
      success: "",
      showModuleSelector: JSON.parse(process.env.VUE_APP_SHOW_MODULE),
      showRelaypoints: JSON.parse(process.env.VUE_APP_RELAYPOINTS),
      appModule: JSON.parse(process.env.VUE_APP_MODULE),
      noIconToolbar: JSON.parse(process.env.VUE_APP_NO_ICON_TOOLBAR),
      noTextToolbar: JSON.parse(process.env.VUE_APP_NO_TEXT_TOOLBAR),
      isNotCapacitor: !isPlatform(window.document.defaultView, "capacitor"),
      canSeeDynamics: JSON.parse(process.env.VUE_APP_CAN_SEE_DYNAMICS)
    };
  },
  created() {
    this.secondary = window
      .getComputedStyle(document.body)
      .getPropertyValue("--ion-color-secondary-rgb");
  },
  computed: {
    numberOfModule() {
      return Object.values(this.appModule).filter(item => item == true).length;
    }
  },
  mounted() {
    this.checkUser();
  },
  methods: {
    checkUser: function() {
      if (this.$store.state.userStore.user) {
        const user = this.$store.state.userStore.user
        if (user.identityStatus == 0 && (!user.hasOwnProperty('hitchHikeDriver') ||user.hitchHikeDriver == null )  && (!user.hasOwnProperty('hitchHikePassenger') || user.hitchHikePassenger == null ) ) {
          this.presentToast(this.$t("HitchHiking.home.identity-covoit"), "success");
        } else if (user.identityStatus == 0) {
          this.presentToast(this.$t("HitchHiking.home.identity-none"), "warning");
        } else if (user.identityStatus == 3) {
          this.presentToast(this.$t("HitchHiking.home.identity-rejected"), "warning");
        }
      }
    },
    showModule: async function(ev) {
      const modal = await popoverController
        .create({
          component: ModuleModal,
          componentProps: {
            propsData: {
              appModule: this.appModule,
              router: this.$router
            },
          },
          event: ev,
          translucent: true,
          cssClass: "modulePopover"
        });

      await modal.present();
    },

    redirectToFAQ: function() {
      this.$router.push({
        name: "article",
        params: { id: 38 }
      });
    },

    redirectToPratique: function() {
      this.$router.push({
        name: "article",
        params: { id: 37 }
      });
    },

    redirectToContact: function() {
      this.$router.push({ name: "carpool-contact" });
    },

    redirectCarpool() {
      this.$router.push({name: 'carpoolsHome'})
    },

    moduleChanged(event) {
      let link;
      switch(event.detail.value) {
        case 'carpool' :
          link = 'carpoolsHome'
          break;
        case 'hitchHiking' :
          link = 'hitchHiking.home'
          break;
        case 'solidary' :
          link = 'solidaryTransport'
          break;
      }

      this.$router.push({name: link})
    },

    goToDynamic() {
      this.$router.push({name: "dynamic"});
    }
  }
};
</script>
